export default function checkIsConnectedToStripe(seller) {
  return seller?.paymentGateways?.stripe?.isActive;
}
